import React from "react";

export default function Social() {
  return (
    <>
      <div className="home__social">
        <a
          href="https://www.facebook.com/mohamed.elrewiny.357?mibextid=ZbWKwL"
          className="home-social-icon"
          target="_blank"
        >
          <i class="bx bxl-facebook"></i>
        </a>

        <a
          href="https://www.instagram.com/m.a.morad22?igsh=MTN5b2hibWc1NDlmcg=="
          className="home-social-icon"
          target="_blank"
        >
          <i class="bx bxl-instagram"></i>
        </a>

        <a
          href="https://www.linkedin.com/in/mohamed-elrewiny-a8457833b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
          className="home-social-icon"
          target="_blank"
        >
          <i class="bx bxl-linkedin"></i>
        </a>

        <a
          href="https://github.com/MohamedElrewiny"
          className="home-social-icon"
          target="_blank"
        >
          <i class="bx bxl-github"></i>
        </a>
      </div>
    </>
  );
}
